import { call, put } from "redux-saga/effects";
import { dashboardService } from "../services/dashboardService";
import { dashboardConstants } from "../actions/constants/dashboardConstants";

function* getCommonReports(): any {
  try {
    const response = yield call(dashboardService.getCommonReports);
    if (response.success) {
      yield put({
        type: dashboardConstants.getCommonReportsSuccess,
        payload: response.resultObject,
      });
    } else {
      yield put({
        type: dashboardConstants.getCommonReportsFailure,
        payload: response.errorMessage,
      });
    }
  } catch (error) {
    yield put({
      type: dashboardConstants.getCommonReportsFailure,
      payload: error,
    });
  }
}

function* getRevenueReport(): any {
  try {
    const response = yield call(dashboardService.getRevenueReport);
    if (response.success) {
      yield put({
        type: dashboardConstants.getRevenueReportSuccess,
        payload: response.resultObject,
      });
    } else {
      yield put({
        type: dashboardConstants.getRevenueReportFailure,
        payload: response.errorMessage,
      });
    }
  } catch (error) {
    yield put({
      type: dashboardConstants.getRevenueReportFailure,
      payload: error,
    });
  }
}

function* getStudentReport(action: any): any {
  try {
    const response = yield call(dashboardService.getStudentReport, action.payload);
    if (response.success) {
      yield put({
        type: dashboardConstants.getStudentReportSuccess,
        payload: response.resultObject,
      });
    } else {
      yield put({
        type: dashboardConstants.getStudentReportFailure,
        payload: response.errorMessage,
      });
    }
  } catch (error) {
    yield put({
      type: dashboardConstants.getStudentReportFailure,
      payload: error,
    });
  }
}

function* getInstructorReport(action: any): any {
  try {
    const response = yield call(dashboardService.getInstructorReport, action.payload);
    if (response.success) {
      yield put({
        type: dashboardConstants.getInstructorReportSuccess,
        payload: response.resultObject,
      });
    } else {
      yield put({
        type: dashboardConstants.getInstructorReportFailure,
        payload: response.errorMessage,
      });
    }
  } catch (error) {
    yield put({
      type: dashboardConstants.getInstructorReportFailure,
      payload: error,
    });
  }
}

export const dashboardSaga = {
  getCommonReports,
  getRevenueReport,
  getStudentReport,
  getInstructorReport,
};
